import config from '@app/config';

// Get the CSRF token from the cookie
export function getCookie(name) {
    let cookieValue: string | undefined;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === name + '=') {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export const getCsrfToken = () => getCookie('csrftoken');

export const FANTASY_ALPHA_HOST = config.fantasyAlphaHost;
export const FANTASY_ALPHA_API_PATH = config.fantasyAlphaApiPath;
export const API_HOST = FANTASY_ALPHA_HOST + FANTASY_ALPHA_API_PATH;

const PROD_ENDPOINT = 'https://fantasy.y.at/api';

type RequestProps = {
    endpoint: string;
    method?: 'GET' | 'POST';
    body?: string;
    signal?: AbortSignal;
    useProd?: boolean;
};
export const makeFantasyAlphaRequest = async <T>({ endpoint, body, method = 'GET', useProd, signal }: RequestProps) => {
    const csrftoken = getCsrfToken();
    const headers = new Headers();
    headers.append('X-CSRFToken', csrftoken || '');
    if (body) headers.append('Content-Type', 'application/json');
    return fetch((useProd ? PROD_ENDPOINT : API_HOST) + endpoint, {
        method,
        credentials: 'include',
        headers,
        signal,
        body,
    }).then((response) => response.json()) as Promise<T>;
};
